<div [class.logged]="session.canAccessLibrary" [class.not-logged]="!session.canAccessLibrary">
    <router-outlet></router-outlet>
</div>
